import React, { useContext, useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';


const AdminChangePassword = () => {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordData, setPasswordData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation(); 
    const user = useSelector(state => state?.user?.user); // Get user details from redux
    
    const [userDetails, setUserDetails] = useState(null);

    const fetchUserDetails = async () => {
        const response = await fetch(SummaryApi.current_user.url, {
            method: SummaryApi.current_user.method,
            credentials: 'include',
            headers: {
                'content-type': 'application/json',
            },
        });
        const responseData = await response.json();
        if (responseData.success) {
            setUserDetails(responseData.data);
        }
    };

    const handleLoading = async () => {
        
        await fetchUserDetails();
    };

    useEffect(() => {
        setLoading(true);
        handleLoading();
        setLoading(false);
    }, []);




    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!passwordData.oldPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
            toast.error("من فضلك قم بكتابة جميع المتطلبات الثلاثة");
            return;
        }

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            toast.error("كلمة المرور الجديدة وتاكيد كلمة المرور الجديدة غير متطابقين");
            return;
        }

        try {
            setLoading(true);

            const response = await fetch(SummaryApi.changePassword.url, {
                method: SummaryApi.changePassword.method,
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                   
                },
                body: JSON.stringify({
                     userId: userDetails?._id,
                    ...passwordData
                })
            });

            const result = await response.json();

            if (response.ok) { // Check if response is OK
                toast.success(result.message);
                setPasswordData({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });
            } else {
                toast.error(result.message || 'فشل تغيير كلمة المرور');
            }
        } catch (error) {
            toast.error('فشل تغيير كلمة المرور');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section id='ChangePassword'>
            <div className='min-h-[calc(100vh-120px)] md:flex'>
                

                {/* Main content */}
                <main className='w-full h-full p-2'>
                    <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                        <form className='pt-6 flex flex-col gap-4 text-right' onSubmit={handleSubmit}>
                            <div>
                                <label>: كلمة المرور القديمة </label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showOldPassword ? "text" : "password"}
                                        placeholder='ادخل كلمة المرور القديمة '
                                        name='oldPassword'
                                        value={passwordData.oldPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowOldPassword(prev => !prev)}>
                                        {showOldPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label>: كلمة المرور الجديدة </label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        placeholder='ادخل كلمة المرور الجديدة '
                                        name='newPassword'
                                        value={passwordData.newPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowNewPassword(prev => !prev)}>
                                        {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>
                                
                            <div>
                                <label>: تأكيد كلمة المرور الجديدة</label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder='ادخل تاكيد كلمة المرور الجديدة '
                                        name='confirmPassword'
                                        value={passwordData.confirmPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowConfirmPassword(prev => !prev)}>
                                        {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>
                            {/* Forgot Password Link */}
                             <Link 
                            to={'/forgot-password'} 
                            className='block w-fit ml-auto hover:underline hover:text-red-600'
                       >
                            هل نسيت كلمة المرور؟
                            </Link>
                            <div className='flex justify-center'>
                                <button
                                    type='submit'
                                    className='flex items-center justify-center bg-blue-900 text-white px-4 py-2 text-sm shadow-md hover:bg-blue-800 transition-colors duration-300 w-[120px] text-center whitespace-nowrap'
                                    disabled={loading}
                                >
                                    {loading ? '... جاري التغيير ' : 'تغيير كلمة المرور'}
                                </button>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </section>
    );
};

export default AdminChangePassword;
